import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import Loading from '../Loading';

import EmptyRenewalPage from './errors/EmptyRenewalPage';
import FetchProposalErrorPage from './errors/FetchProposalErrorPage';

import {
  fetchYardiLease,
  fetchProposals,
  fetchScheduleAs,
  clearDetails,
} from '../../store/actions';

const PAGE_STATES = {
  loading: 'loading',
  error: 'error',
  loaded: 'loaded',
  no_renewals: 'no_renewals',
};

const FetchProposals = ({
  leaseId,
  closeWizard,
  pageIndex,
  setPageIndex,
  lastPageIndex,
  showWizardControls,
  hideWizardControls,
  fetchYardiLease,
  fetchProposals,
  fetchScheduleAs,
  clearDetails,
}) => {
  const [pageState, setPageState] = useState(PAGE_STATES.loading);

  useEffect(() => {
    getRenewalProposals(leaseId);
    clearDetails();
    // eslint-disable-next-line
  }, []);

  const moveForward = () => {
    if (pageIndex !== lastPageIndex) {
      return setPageIndex(pageIndex + 1);
    }
  };

  const getRenewalProposals = async leaseId => {
    try {
      if (pageState !== PAGE_STATES.loading) {
        setPageState(PAGE_STATES.loading);
      }
      await fetchScheduleAs();
      await fetchYardiLease(leaseId);
      const proposals = await fetchProposals(leaseId);

      proposals.length ? setPageState(PAGE_STATES.loaded) : setPageState(PAGE_STATES.no_renewals);
    } catch (err) {
      setPageState(PAGE_STATES.error);
    }
  };

  const handleRetry = () => {
    getRenewalProposals(leaseId);
  };

  if (pageState === PAGE_STATES.loading) {
    return <Loading />;
  } else if (pageState === PAGE_STATES.error) {
    return <FetchProposalErrorPage handleRetry={handleRetry} />;
  } else if (pageState === PAGE_STATES.no_renewals) {
    return <EmptyRenewalPage handleRetry={handleRetry} />;
  } else if (pageState === PAGE_STATES.loaded) {
    moveForward();
    return null;
  }
};

const mapStateToProps = store => ({
  leaseId: store.landlord.renewals.leaseId,
});

const mapDispatchToProps = {
  fetchYardiLease,
  fetchProposals,
  fetchScheduleAs,
  clearDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(FetchProposals);
